/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_RevokedInputs */

const vi_print_admin_revoked = /** @type {(inputs: Print_Admin_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thu hồi`)
};

/**

* @param {Print_Admin_RevokedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_revoked = /** @type {((inputs?: Print_Admin_RevokedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_RevokedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_revoked(inputs)
});